import i18n from '@/plugins/i18n';

const createBubble = ({ channel, replier, channelMap, replierMap, value }) => {
  const channelIndex = channelMap[channel];
  const replierIndex = replierMap[replier];
  return {
    name: replier,
    channel,
    x: channelIndex,
    y: replierIndex,
    z: value,
  };
};

const createIndexMap = (values) => {
  return values.reduce((map, value, index) => {
    map[value] = index;
    return map;
  }, {});
};

const calculateTotalSum = (data) => {
  return data.reduce((total, { z }) => total + z, 0);
};

const generateSeriesData = (seriesObject, replierMap, channelMap) => {
  return Object.entries(seriesObject).map(([replier, data]) => {
    const totalSum = calculateTotalSum(data);
    data.push({
      name: replier,
      channel: i18n.t('components.PerformanceByChannel.label.bubble.total'),
      x: Object.values(channelMap).slice(-1)[0] + 1,
      y: replierMap[replier],
      z: totalSum,
    });
    return { name: replier, data };
  });
};

const generateTotalPerChannel = (channelSums, channelMap, replierMap) => {
  return Object.entries(channelSums).map(([channel, sum]) => {
    const nameTotalChannel = `${i18n.t('components.PerformanceByChannel.label.bubble.total')} - ${channel}`;
    return {
      name: nameTotalChannel,
      data: [{ name: nameTotalChannel, channel, x: channelMap[channel], y: Object.values(replierMap).slice(-1)[0] + 1, z: sum }],
    };
  });
};

export default {
  performanceByChannel: {
    servicePath: 'PerformanceByChannel',
    series: ({ points, axes }) => {
      if (!points || points.length === 0) return [];

      const replierMap = createIndexMap(axes[1].values);
      const channelMap = createIndexMap(axes[0].values);

      const seriesObject = {};
      const channelSums = {};

      points.forEach(({ coordinates: { channel, replier }, value }) => {
        if (channel in channelMap && replier in replierMap) {
          const bubble = createBubble({ channel, replier, channelMap, replierMap, value });
          seriesObject[replier] = seriesObject[replier] || [];
          seriesObject[replier].push(bubble);

          channelSums[channel] = (channelSums[channel] || 0) + value;
        }
      });

      const seriesData = generateSeriesData(seriesObject, replierMap, channelMap);
      const totalPerChannel = generateTotalPerChannel(channelSums, channelMap, replierMap);
      seriesData.push(...totalPerChannel);

      return seriesData;
    },
    getTooltipHTML: (point) => {
      return `
        <span>
          <span style="display: block;">${i18n.t('components.PerformanceByChannel.label.bubble.replier')}: <b>${point.name}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByChannel.label.bubble.channel')}: <b>${point.channel}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByChannel.label.bubble.value')}: <b>${point.z}</b></span>
        </span>
      `;
    },
  },
};
